/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Docx_AInputs */

const en_wc_faq_docx_a = /** @type {(inputs: Wc_Faq_Docx_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. It opens and saves .docx natively and imports older Word 97-2003 .doc files. Because WordCraft is still in alpha, keep a copy of important documents and check complex layouts (charts, SmartArt) after a round trip.`)
};

/**
* | output |
* | --- |
* | "Yes. It opens and saves .docx natively and imports older Word 97-2003 .doc files. Because WordCraft is still in alpha, keep a copy of important documents and..." |
*
* @param {Wc_Faq_Docx_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_docx_a = /** @type {((inputs?: Wc_Faq_Docx_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Docx_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_docx_a(inputs)
});
export { wc_faq_docx_a as "wc.faq.docx.a" }